'use client';

import { ProjectResponseRatingScaleSelect } from '@/shared-project-response-message-renderers';

import SurveyAiFormsAiSectionQuestionTitle from './survey-ai-forms-ai-section-question-title';
import { useAiRatingQuestion } from './survey-ai-forms-ai-section-question.hooks';
import type { AISectionQuestionsBaseProps } from './survey-ai-forms-ai-section-questions.types';
import SurveyAiFormsInputComposer from './survey-ai-forms-input-composer';

interface Props extends AISectionQuestionsBaseProps {
  value: string;
  onChange: (value: string | number) => void;
  loading?: boolean;
}

export default function SurveyAiFormsAiSectionRatingQuestion({
  question,
  value,
  transcriptValue = '',
  onChange,
  onTranscriptChange,
  onSubmit,
  onNext,
  hasValue = false,
  responseMode,
  isActive = true,
  onFocus,
  registerVoiceStopCallback,
  loading = false,
  isMobile = false,
  isUserVoiceEnabled = false,
}: Props) {
  const { isListening, options, canSubmit, handleInputComposerSubmit } =
    useAiRatingQuestion({
      question,
      value,
      transcriptValue,
      onChange,
      onSubmit,
      onNext,
      hasValue,
    });

  return (
    <div data-test='rating-question' className='flex w-full flex-col gap-8'>
      <SurveyAiFormsAiSectionQuestionTitle
        text={question.text}
        assets={question.assets}
      />

      <ProjectResponseRatingScaleSelect
        app='survey'
        options={options.map((o) => ({ label: o.label, value: o.value }))}
        value={value}
        onClick={onChange}
        optionRenderType={question.optionRenderType ?? undefined}
        className='border-0 bg-transparent p-0 shadow-none backdrop-blur-none'
      />

      <SurveyAiFormsInputComposer
        value={transcriptValue}
        onChange={onTranscriptChange}
        onSubmit={handleInputComposerSubmit}
        responseMode={responseMode}
        isActive={isActive}
        onFocus={onFocus}
        registerVoiceStopCallback={registerVoiceStopCallback}
        instanceId={question.id}
        canSubmit={canSubmit}
        isListening={isListening}
        questionType={question.type}
        loading={loading}
        isMobile={isMobile}
        isUserVoiceEnabled={isUserVoiceEnabled}
      />
    </div>
  );
}
